import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type ModalType = 'privacy' | 'terms' | 'refund' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-navy text-white py-8 px-4" data-id="element-109">
        <div className="max-w-6xl mx-auto" data-id="element-110">
          {/* Main Footer Content */}
          <div className="text-center mb-6" data-id="element-111">
            <h3 className="text-xl font-bold mb-2" data-id="element-112">Mega Music Pack</h3>
            <p className="text-sm text-gray-300" data-id="element-113">
              Complete curriculum for music educators Pre-K through Grade 12
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 mb-6 text-sm" data-id="element-114">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-300 hover:text-white transition-colors" data-id="element-115">
              Privacy Policy
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-gray-300 hover:text-white transition-colors" data-id="element-116">
              Terms of Service
            </button>
            <button onClick={() => setActiveModal('refund')} className="text-gray-300 hover:text-white transition-colors" data-id="element-117">
              Refund Policy
            </button>
            <a href="mailto:support@megamusicpack.com" className="text-gray-300 hover:text-white transition-colors" data-id="element-118">
              Contact
            </a>
          </div>

          {/* Copyright */}
          <div className="text-center text-sm text-gray-400" data-id="element-119">
            <p data-id="element-120">
              &copy; {new Date().getFullYear()} Mega Music Pack. All rights
              reserved.
            </p>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Privacy Policy" data-id="element-121">
        <div className="space-y-4" data-id="element-122">
          <p className="text-sm text-gray-600" data-id="element-123">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-124">
            Information We Collect
          </h3>
          <p data-id="element-125">
            When you purchase the Mega Music Pack, we collect information
            necessary to process your order, including your name, email address,
            and payment information. We use secure payment processors and do not
            store your credit card details on our servers.
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-126">
            How We Use Your Information
          </h3>
          <p data-id="element-127">We use your information to:</p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-128">
            <li data-id="element-129">Process and deliver your purchase</li>
            <li data-id="element-130">Send you download links and product updates</li>
            <li data-id="element-131">Provide customer support</li>
            <li data-id="element-132">Improve our products and services</li>
          </ul>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-133">
            Data Security
          </h3>
          <p data-id="element-134">
            We implement industry-standard security measures to protect your
            personal information. All transactions are encrypted using SSL
            technology.
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-135">
            Third-Party Services
          </h3>
          <p data-id="element-136">
            We use trusted third-party services for payment processing and email
            delivery. These services have their own privacy policies and we
            encourage you to review them.
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-137">Your Rights</h3>
          <p data-id="element-138">
            You have the right to access, update, or delete your personal
            information at any time. Contact us at privacy@megamusicpack.com for
            any privacy-related requests.
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-139">Contact Us</h3>
          <p data-id="element-140">
            If you have questions about this Privacy Policy, please contact us
            at privacy@megamusicpack.com.
          </p>
        </div>
      </LegalModal>

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Terms of Service" data-id="element-141">
        <div className="space-y-4" data-id="element-142">
          <p className="text-sm text-gray-600" data-id="element-143">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-144">
            Agreement to Terms
          </h3>
          <p data-id="element-145">
            By purchasing and using the Mega Music Pack, you agree to be bound
            by these Terms of Service. If you do not agree to these terms,
            please do not purchase or use our products.
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-146">
            License Grant
          </h3>
          <p data-id="element-147">
            Upon purchase, you are granted a non-exclusive, non-transferable
            license to use the Mega Music Pack materials for your personal
            classroom use. This includes:
          </p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-148">
            <li data-id="element-149">Editing and customizing materials for your classroom</li>
            <li data-id="element-150">Printing materials for your students</li>
            <li data-id="element-151">Using materials in your teaching practice</li>
          </ul>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-152">Restrictions</h3>
          <p data-id="element-153">You may NOT:</p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-154">
            <li data-id="element-155">
              Share, distribute, or resell the materials to other educators
            </li>
            <li data-id="element-156">
              Post the materials publicly online or in file-sharing services
            </li>
            <li data-id="element-157">Claim the materials as your own original work</li>
            <li data-id="element-158">
              Use the materials for commercial purposes beyond your classroom
            </li>
          </ul>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-159">
            Refund Policy
          </h3>
          <p data-id="element-160">
            We offer a 7-day money-back guarantee. If you are not satisfied with
            the Mega Music Pack, contact us within 7 days of purchase for a full
            refund. See our Refund Policy for details.
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-161">
            Updates and Changes
          </h3>
          <p data-id="element-162">
            All future updates to the Mega Music Pack are included free of
            charge. We reserve the right to modify these terms at any time, with
            changes effective upon posting.
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-163">
            Limitation of Liability
          </h3>
          <p data-id="element-164">
            The Mega Music Pack is provided "as is" without warranties of any
            kind. We are not liable for any damages arising from the use or
            inability to use our materials.
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-165">Contact</h3>
          <p data-id="element-166">
            For questions about these Terms of Service, contact us at
            support@megamusicpack.com.
          </p>
        </div>
      </LegalModal>

      <LegalModal isOpen={activeModal === 'refund'} onClose={() => setActiveModal(null)} title="Refund Policy" data-id="element-167">
        <div className="space-y-4" data-id="element-168">
          <p className="text-sm text-gray-600" data-id="element-169">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-170">
            7-Day Money-Back Guarantee
          </h3>
          <p data-id="element-171">
            We stand behind the quality of the Mega Music Pack. If you are not
            completely satisfied with your purchase, we offer a full refund
            within 7 days of your purchase date.
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-172">
            How to Request a Refund
          </h3>
          <p data-id="element-173">To request a refund:</p>
          <ol className="list-decimal pl-6 space-y-2" data-id="element-174">
            <li data-id="element-175">
              Email us at refunds@megamusicpack.com within 7 days of purchase
            </li>
            <li data-id="element-176">
              Include your order number and email address used for purchase
            </li>
            <li data-id="element-177">
              Briefly explain why the product didn't meet your needs (optional
              but helpful)
            </li>
          </ol>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-178">
            Refund Processing
          </h3>
          <p data-id="element-179">
            Once we receive your refund request, we will process it within 2-3
            business days. Refunds will be issued to the original payment
            method. Please allow 5-10 business days for the refund to appear in
            your account, depending on your bank or credit card company.
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-180">
            What Happens After a Refund
          </h3>
          <p data-id="element-181">
            After a refund is processed, your access to download the materials
            will be revoked. We trust that you will delete any downloaded files
            in good faith.
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-182">
            No Questions Asked
          </h3>
          <p data-id="element-183">
            We believe in making this risk-free for you. You don't need to
            provide a detailed explanation for your refund request. If the Mega
            Music Pack doesn't work for you, we want to make it right.
          </p>

          <h3 className="text-lg font-semibold text-navy mt-6" data-id="element-184">Questions?</h3>
          <p data-id="element-185">
            If you have any questions about our refund policy, please contact us
            at support@megamusicpack.com. We're here to help.
          </p>
        </div>
      </LegalModal>
    </>;
}